import { render } from "./GroupBuilderComponent.vue?vue&type=template&id=7a79dfc5"
import script from "./GroupBuilderComponent.vue?vue&type=script&lang=js"
export * from "./GroupBuilderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__